// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1V9Bf","toggleWrap":"styles_toggleWrap__GrfOd","content":"styles_content__3b1D8","selectAreaCode":"styles_selectAreaCode__3e5Rs"};